import { HomeworkSubmittedStudentPage } from './HomeworkSubmittedStudentPage';
export default HomeworkSubmittedStudentPage;
